import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Radio, RadioGroup, styled } from '@mui/material';

import { getPctgColor } from '»utils/pctgColors';

export const WrapperDetail = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateAreas: `
  "qntTotal vAtual vPotencias ."
  "qntDisponivel vAquisicao vDiaria ."
  "vNominal vAtualMoeda carteira ."
  `,
  gridColumnGap: '13px',
  [theme.breakpoints.up('md')]: {
    gridTemplateAreas: `
  "qntTotal vNominal vAtual vPotencias vDiaria"
  "qntDisponivel vAquisicao vAtualMoeda carteira ."
    `,
    gridColumnGap: '24px',
  },
}));

export const StockType = styled('span')(({ theme }) => ({
  fontWeight: 'bold',
  fontSize: '24px',
  color: theme.palette.colors.onSecondaryAndDetailBackground,
  marginTop: 0,
  lineHeight: 'normal',
}));

export const WrapperDataRow = styled('div')(({
  theme,
  isButton,
  isVariationValues,
  isFirstVariationWrapper,
  isSecondVariationWrapper,
}) => {
  const getGap = (breakpoint) => {
    if (breakpoint === 'xl') {
      if (isVariationValues) return '32px';
      if (isSecondVariationWrapper) return '40px';
      return '24px';
    }

    if (breakpoint === 'xxl') {
      if (isSecondVariationWrapper) return '92px';
      return '40px';
    }

    if (isFirstVariationWrapper) return '56px';

    if (isVariationValues || isSecondVariationWrapper) return '24px';

    return 0;
  };

  const getMarginTop = () => {
    if (isButton) return '38px';

    if (isFirstVariationWrapper || isSecondVariationWrapper) return '32px';

    return 0;
  };

  return {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    marginTop: getMarginTop(),
    gap: getGap(),
    [theme.breakpoints.up('xl')]: {
      display: 'flex',
      gap: getGap('xl'),
    },
    [theme.breakpoints.up('xxl')]: {
      gap: getGap('xxl'),
    },
  };
});

export const WrapperDataColumn = styled('div')(({ alignStart }) => ({
  display: 'flex',
  gap: '8px',
  alignItems: alignStart ? 'flex-start' : 'flex-end',
  flexDirection: 'column',
}));

export const WrapperDataInfo = styled('div')(
  ({ isVariation, theme, alignStart }) => ({
    display: 'flex',
    flexDirection: isVariation ? 'column' : 'row',
    alignItems: alignStart ? 'flex-start' : 'flex-end',
    gap: isVariation ? '2px' : '4px',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'row',
      gap: '8px',
      alignItems: 'center',
    },
  }),
);

export const WrapperDataWalletRight = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '18px',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'column-reverse',
    gap: 0,
  },
}));

export const Wrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'variationPctg',
})(({ theme, variationPctg }) => {
  const floatValue = parseFloat(variationPctg);

  const getColor = () => {
    if (floatValue !== undefined) {
      if (floatValue > 0) {
        return theme.palette.colors.up;
      }
      if (floatValue === 0) {
        return theme.palette.colors.inert;
      }
      return theme.palette.colors.down;
    }
    return theme.palette.colors.onSecondaryAndDetailBackground;
  };

  return {
    width: '100%',
    height: '138px',
    border: `solid 1px ${theme.palette.colors.borderLine}`,
    backgroundColor: theme.palette.colors.secondaryBackground,
    padding: '0 16px 0 25px',
    borderRadius: '5px',
    borderTopRightRadius: '8px',
    borderBottomRightRadius: '8px',
    marginTop: '24px',
    display: 'flex',
    flexDirection: 'row',
    gap: 0,
    justifyContent: 'space-between',
    position: 'relative',
    '& .swiper-wrapper': {
      height: 'auto',
    },
    '& .swiper-pagination-bullet-active': {
      color: theme.palette.colors.highlight,
      '--swiper-theme-color': theme.palette.colors.highlight,
    },
    '& .swiper-pagination': {
      marginLeft: '28px',
      '&-horizontal': {
        top: 'auto',
        bottom: 'auto',
      },
      '& .swiper-pagination-bullet': {
        margin: '0 6px 0 0',
        '&:last-of-type': {
          margin: '0 0 0 6px',
        },
      },
    },
    '&::before': {
      content: `''`,
      position: 'absolute',
      backgroundColor: getColor(),
      width: '8px',
      height: '100%',
      bottom: 0,
      left: 0,
      borderTopLeftRadius: '4px',
      borderBottomLeftRadius: '4px',
    },
    [theme.breakpoints.up(1180)]: {
      paddingLeft: '33px',
      paddingRight: '24px',
    },
    [theme.breakpoints.up('xl')]: {
      justifyContent: 'space-evenly',
      paddingRight: '12px',
      paddingLeft: '12px',
    },
  };
});

export const InfoDiv = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
}));

export const WrapperButtons = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: '4px',
  [theme.breakpoints.up('md')]: {
    position: 'relative',
  },
}));

export const DataLabel = styled('span')(({ theme }) => ({
  fontSize: '10px',
  lineHeight: 'normal',
  color: theme.palette.colors.lower,
  fontWeight: 500,
  [theme.breakpoints.up('md')]: {
    fontSize: '12px',
  },
}));

export const DataValue = styled('span', {
  shouldForwardProp: (prop) =>
    prop !== 'value' &&
    prop !== 'isOrder' &&
    prop !== 'isBigger' &&
    prop !== 'isVariation',
})(({ value, theme, isOrder, isBigger, isVariation }) => {
  const floatValue = parseFloat(value);

  const isVariationNull = isVariation && value === null;

  const getFontSize = (md) => {
    if (isOrder) {
      if (md) {
        return 12;
      }
      return 10;
    }
    if (!isNaN(floatValue)) {
      if (isVariation) {
        return 32;
      }
      if (md) {
        return 18;
      }
      return 14;
    }
    if (isBigger) {
      if (md) {
        return 32;
      }
      return 22;
    }
    if (md) {
      return 14;
    }
    return 10;
  };

  const getVariationChar = () => {
    if (!isNaN(floatValue)) {
      if (floatValue > 0) {
        return '"+"';
      }
      if (floatValue === 0) {
        return '""';
      }
    }
    return '""';
  };

  return {
    fontSize: getFontSize(),
    lineHeight: 'normal',
    fontWeight: 500,
    color: getPctgColor(floatValue, theme),
    marginRight: isVariationNull && 43,
    '&::before': {
      content: getVariationChar(),
    },
    [theme.breakpoints.up('md')]: {
      fontSize: getFontSize('md'),
    },
  };
});

export const FontAwesomeIconStyled = styled(FontAwesomeIcon)(({
  theme,
  value,
}) => {
  const floatValue = parseFloat(value);

  return {
    color: getPctgColor(floatValue, theme),
    fontSize: !isNaN(floatValue) && value === 0 ? 35 : 40,
    marginLeft: 8,
  };
});

export const WrapperColumn = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
}));

export const LineSeparator = styled('div')(({ theme }) => ({
  width: 317,
  backgroundColor: theme.palette.colors.lower,
  height: 1,
  margin: '16px 0',
  [theme.breakpoints.up('md')]: {
    width: 555,
  },
}));

export const WrapperStockData = styled('div')(({ theme }) => ({
  marginRight: '26px',
  display: 'flex',
  flexDirection: 'column',
  gap: 0,
  [theme.breakpoints.up('md')]: {
    gap: 16,
    flexDirection: 'row',
    marginRight: 32,
  },
}));

export const WrapperDataOrder = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '8px',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    gap: '24px',
  },
}));

export const WrapperStockDataRight = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-end',
}));

export const WrapperDataOrderRight = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.up('md')]: {
    gap: 0,
  },
}));

export const WrapperDataOrderLeft = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row-reverse',
    alignItems: 'flex-start',
  },
}));

export const WrapperDataOrderText = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '3px',
  [theme.breakpoints.up('md')]: {
    gap: '4px',
  },
}));

export const WrapperPills = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '9px',
  marginBottom: '8px',
  [theme.breakpoints.up('md')]: {
    gap: '16px',
    marginBottom: '6px',
  },
}));
export const WrapperFirstColumn = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
}));
export const WrapperMiddleColumn = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  marginTop: '27px',
  [theme.breakpoints.up('md')]: {
    marginTop: '8px',
  },
}));
export const WrapperButtomColumn = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  marginTop: 6,
  [theme.breakpoints.up('md')]: {
    marginTop: '8px',
  },
}));

export const CarouselWrapper = styled(Box)(({ theme }) => ({
  width: '56px',
  display: 'flex',
  justifyContent: 'center',
  [theme.breakpoints.up('xl')]: {
    display: 'none',
  },
}));

export const RadioGroupStyled = styled(RadioGroup)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  position: 'absolute',
  bottom: 0,
  [theme.breakpoints.up('xl')]: {
    display: 'none',
  },
}));

export const RadioStyled = styled(Radio)(() => ({
  padding: '11px 0 8px 0',
  '&:nth-child(1)': {
    paddingRight: '6px',
    paddingLeft: 0,
  },
}));

export const DetailRadio = styled('span')(({ theme }) => ({
  borderRadius: '50%',
  width: '8px',
  height: '8px',
  backgroundColor: theme.palette.colors.off,
}));

export const DetailCheckedRadio = styled('span')(({ theme }) => ({
  borderRadius: '50%',
  width: '8px',
  height: '8px',
  backgroundColor: theme.palette.colors.highlight,
}));
